"use client";

import { cn } from "@/lib/utils";

interface CircularProgressProps {
  value: number;
  size?: number;
  showLabel?: boolean;
  className?: string;
  strokeWidth?: number;
  wrapperClassName?: string;
  labelClassName?: string;
  circleStrokeWidth?: number;
  shape?: "square" | "round";
  progressClassName?: string;
  progressStrokeWidth?: number;
  renderLabel?: (progress: number) => React.ReactNode;
}

export function CircularProgress({
  value,
  renderLabel,
  className,
  showLabel,
  strokeWidth,
  wrapperClassName,
  labelClassName,
  size = 100,
  progressClassName,
  shape = "round",
  circleStrokeWidth = 10,
  progressStrokeWidth = 10,
}: CircularProgressProps) {
  const radius = size / 2 - 10;
  const circumference = Math.ceil(3.14 * radius * 2);
  const percentage = Math.ceil(circumference * ((100 - value) / 100));

  const viewBox = `-${size * 0.125} -${size * 0.125} ${size * 1.25} ${size * 1.25}`;
  const style = { transform: "rotate(-90deg)" };

  return (
    <div className={cn("relative w-fit h-fit", wrapperClassName)}>
      <svg width={size} height={size} viewBox={viewBox} version="1.1" xmlns="http://www.w3.org/2000/svg" style={style} className="relative">
        <circle
          r={radius}
          cx={size / 2}
          cy={size / 2}
          fill="transparent"
          strokeWidth={strokeWidth ?? circleStrokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset="0"
          className={cn("stroke-foreground/10", className)}
        />
        <circle
          r={radius}
          cx={size / 2}
          cy={size / 2}
          fill="transparent"
          strokeLinecap={shape}
          strokeDashoffset={percentage}
          strokeDasharray={circumference}
          strokeWidth={strokeWidth ?? progressStrokeWidth}
          className={cn("stroke-primary", progressClassName)}
        />
      </svg>
      {showLabel ? <div className={cn("absolute inset-0 flex items-center justify-center", labelClassName)}>{renderLabel ? renderLabel(value) : value}</div> : null}
    </div>
  );
}
